import { useEffect, useRef } from "react";
// ❌ REMOVED: Visibility import (v0.66.0 - all memos are private)
import type { EditorRefActions } from "../Editor";
import { cacheService, journalService } from "../services";
import { useEditorContext } from "../state";

export const useJournalInit = (
  editorRef: React.RefObject<EditorRefActions | null>,
  memoName: string | undefined,
  cacheKey: string | undefined,
  username: string,
  autoFocus?: boolean,
  initialTicker?: string,
  // ❌ REMOVED: defaultVisibility parameter (v0.66.0 - all memos are private)
) => {
  const { actions, dispatch } = useEditorContext();
  const initializedRef = useRef(false);
  const cachedContentRef = useRef<string | null>(null);

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    const init = async () => {
      dispatch(actions.setLoading("loading", true));

      try {
        if (memoName) {
          // Load existing memo
          const loadedState = await journalService.load(memoName);
          dispatch(
            actions.initMemo({
              content: loadedState.content,
              metadata: loadedState.metadata,
              timestamps: loadedState.timestamps,
            }),
          );
        } else {
          // Load from cache for new memo
          const cacheKeyFull = cacheService.key(username, cacheKey);
          const cachedContent = cacheService.load(cacheKeyFull);
          cachedContentRef.current = cachedContent;

          if (cachedContent) {
            dispatch(actions.updateContent(cachedContent));
          }
          // ❌ REMOVED: Apply default visibility for new memos (v0.66.0 - all memos are private)
        }
      } catch (error) {
        console.error("Failed to initialize editor:", error);
      } finally {
        dispatch(actions.setLoading("loading", false));

        if (autoFocus) {
          setTimeout(() => {
            editorRef.current?.focus();
          }, 100);
        }

        // Insert initial ticker if provided (only for new memos without cached content)
        if (initialTicker && !memoName && !cachedContentRef.current) {
          setTimeout(() => {
            // Use insertStock if available (Lexical editor), otherwise insert text
            const editorActions = editorRef.current as any;
            if (editorActions?.insertStock) {
              editorActions.insertStock(initialTicker);
            } else if (editorActions?.insertText) {
              editorActions.insertText(`$${initialTicker}`, "", " ");
            }
            // Focus after inserting ticker
            editorRef.current?.focus();
          }, 200);
        }
      }
    };

    init();
  }, [memoName, cacheKey, username, autoFocus, initialTicker, /* ❌ REMOVED: defaultVisibility, */ actions, dispatch, editorRef]);
};
